module.exports = __webpack_public_path__ + "static/pt-moa-graphic-mobile-0a48ae38e56aa30ce894d1a9b4af9435.png";